import {
  subDays,
  subHours,
  subMinutes,
  subMonths,
  subSeconds,
  subYears,
} from 'date-fns';

const subDateUnits = (date, value, unit) => {
  const num = Number(value);

  switch(unit) {
    case 'h': return subHours(date, num);
    case 'm': return subMinutes(date, num);
    case 's': return subSeconds(date, num);
    case 'd': return subDays(date, num);
    case 'M': return subMonths(date, num);
    case 'y': return subYears(date, num);
    default: throw new Error('Unsupported date unit');
  }
};

export {
  subDateUnits
};